import { GeoPoint } from 'api/interfaces/Geo'

export const calculateDistance = (pointA: GeoPoint, pointB: GeoPoint): number => {
  if (!pointA || !pointB) {
    return 0
  }
  const R = 6371e3
  const phi1 = (pointA.lat * Math.PI) / 180
  const phi2 = (pointB.lat * Math.PI) / 180
  const deltaPhi = ((pointB.lat - pointA.lat) * Math.PI) / 180
  const deltaLamda = ((pointB.lng - pointA.lng) * Math.PI) / 180

  const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLamda / 2) * Math.sin(deltaLamda / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c
}

export const calculateCenterPoint = (points: GeoPoint[]): GeoPoint | null => {
  if (!points || points.length === 0) {
    return null
  }

  const validPoints = points.filter(point => point.lat && point.lng)
  if (validPoints.length === 0) {
    return null
  }

  const minLat = Math.min(...validPoints.map(p => p.lat))
  const maxLat = Math.max(...validPoints.map(p => p.lat))
  const minLng = Math.min(...validPoints.map(p => p.lng))
  const maxLng = Math.max(...validPoints.map(p => p.lng))

  const centerLat = (minLat + maxLat) / 2
  const centerLng = (minLng + maxLng) / 2

  return {
    lat: centerLat,
    lng: centerLng
  }
}

export const calculateOptimalZoom = (points: GeoPoint[]): number => {
  if (!points || points.length === 0) {
    return 10
  }

  const validPoints = points.filter(point => point.lat && point.lng)
  if (validPoints.length === 0) {
    return 10
  }

  if (validPoints.length === 1) {
    return 12
  }

  const lats = validPoints.map(p => p.lat)
  const lngs = validPoints.map(p => p.lng)

  const latRange = Math.max(...lats) - Math.min(...lats)
  const lngRange = Math.max(...lngs) - Math.min(...lngs)

  const maxRange = Math.max(latRange, lngRange)

  const rangeForZoom = maxRange * 1.5

  if (rangeForZoom > 20) return 3
  if (rangeForZoom > 10) return 4
  if (rangeForZoom > 5) return 5
  if (rangeForZoom > 2) return 6
  if (rangeForZoom > 1) return 7
  if (rangeForZoom > 0.5) return 8
  if (rangeForZoom > 0.25) return 9
  if (rangeForZoom > 0.1) return 10
  if (rangeForZoom > 0.05) return 11
  return 12
}
